import { RiDownload2Line } from "react-icons/ri";

import { primerDownload } from "consts/urls";

const PrimerDownload = ({
  insight,
  authenticated,
  isMobile,
  isPrimer,
  trackActivity,
}: {
  insight: any;
  authenticated: boolean;
  isMobile?: boolean;
  isPrimer?: boolean;
  trackActivity: (eventName: string, payload: any) => void;
}) => {
  if (!isPrimer || !authenticated || !insight?.primaryEntity?.shortSecurity)
    return null;

  const url = primerDownload.replace(
    "{ticker}",
    insight.primaryEntity.shortSecurity
  );

  const onClick = () => {
    trackActivity("insight.primer_download", insight);

    const link = document.createElement("a");
    link.href = url;
    link.download = `primer-${insight.primaryEntity.shortSecurity}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (isMobile) {
    return (
      <button
        onClick={onClick}
        className="bg-white outline-none w-full text-left p-[10px] text-active-black border-none"
      >
        <RiDownload2Line size={18} className="mr-[5px] ml-[-3px]" />
        Download Primer
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center gap-[8px] w-full mt-[10px] h-[38px] rounded-full border border-solid border-smart-teal text-smart-teal text-[14px] font-bold bg-white hover:bg-smart-teal hover:text-white transition-colors outline-none cursor-pointer"
    >
      <RiDownload2Line size={18} />
      Download
    </button>
  );
};

export default PrimerDownload;
